import cx from 'classnames';
import PropTypes from 'prop-types';

import { CustomTypography, TYPOGRAPHY_VARIANT } from 'src/components/CustomTypography';
import { TopNavigationBarItems } from 'src/views/TopNavigationBarItems';

import { useStyles } from './useStyles';

export const PageHeader = ({ className, title, children, largeTitle, titleComponentSlot }) => {
  const styles = useStyles();

  return (
    <div className={cx(styles.root, className)}>
      {titleComponentSlot ? (
        titleComponentSlot
      ) : (
        <CustomTypography
          className={styles.title}
          variant={largeTitle ? TYPOGRAPHY_VARIANT.h1 : TYPOGRAPHY_VARIANT.h2}
        >
          {title}
        </CustomTypography>
      )}

      <div className={styles.childrenWrapper}>{children}</div>

      <TopNavigationBarItems />
    </div>
  );
};

PageHeader.propTypes = {
  className: PropTypes.string,
  title: PropTypes.string,
  largeTitle: PropTypes.bool,
  children: PropTypes.node,
  titleComponentSlot: PropTypes.node,
};

PageHeader.defaultProps = {
  title: '',
  className: '',
  largeTitle: false,
  children: null,
  titleComponentSlot: null,
};
